import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Flavors } from "./components/flavors";
import { WorkshopPreview } from "./components/workshop-preview";
import { WorkshopsPage } from "./components/workshops-page";
import { Contact } from "./components/contact";
import { ContactFormModal } from "./components/contact-form-modal";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// Main Page Component
const MainPage = ({
  landingPageData,
  tab,
  setTab,
  page,
  setPage,
  flavorTab,
  setFlavorTab,
  gallery,
  filteredData,
}) => {
  // Handle hash navigation on page load
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const sectionId = hash.substring(1); // Remove the # symbol
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80; // Account for fixed navbar height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 100);
    }
  }, []);

  return (
    <div>
      <Navigation />
      <Header />
      <Features data={landingPageData.Features} />
      <Flavors
        data={landingPageData.Team}
        flavorTab={flavorTab}
        setFlavorTab={setFlavorTab}
      />
      <Services data={landingPageData.Services} />
      <Gallery
        data={gallery}
        tab={tab}
        setTab={setTab}
        page={page}
        setPage={setPage}
        length={Math.ceil(filteredData.length / 18)}
      />
      <Testimonials data={landingPageData.Testimonials} />
      <About data={landingPageData.About} />
      <WorkshopPreview data={landingPageData.Workshops} />
      <Contact
        data={landingPageData.Contact}
        flavorsData={landingPageData.Team}
      />
    </div>
  );
};

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [tab, setTab] = useState("all");
  const [page, setPage] = useState(1);
  const [flavorTab, setFlavorTab] = useState("cakes");
  const [gallery, setGallery] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  // 1. Update filtered data when tab or original data changes
  useEffect(() => {
    if (!landingPageData?.Gallery) return;

    const filtered =
      tab === "all"
        ? landingPageData.Gallery
        : landingPageData.Gallery.filter((item) => item.category === tab);

    setFilteredData(filtered);
    setPage(1); // reset to first page when filter changes
  }, [tab, landingPageData]);

  // 2. Update paginated gallery data when filteredData or page changes
  useEffect(() => {
    const getPageData = (data, page) => {
      const pageSize = 18;
      const start = (page - 1) * pageSize;
      return data.slice(start, start + pageSize);
    };

    setGallery(getPageData(filteredData, page));
  }, [filteredData, page]);

  return (
    <Router>
      <ContactFormModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        contactData={landingPageData.Contact}
        flavorsData={landingPageData.Team}
      />
      <Routes>
        <Route
          path="/"
          element={
            <MainPage
              landingPageData={landingPageData}
              tab={tab}
              setTab={setTab}
              page={page}
              setPage={setPage}
              flavorTab={flavorTab}
              setFlavorTab={setFlavorTab}
              gallery={gallery}
              filteredData={filteredData}
            />
          }
        />
        <Route
          path="/workshops"
          element={<WorkshopsPage data={landingPageData.Workshops} />}
        />
      </Routes>
    </Router>
  );
};

export default App;
